<nb-card class="dialog-card">
  <nb-card-header>
    <h5>{{ "pages.dozent.participants.createCourse" | translate }}</h5>
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <label class="label">{{ "pages.dozent.participants.courseName" | translate }} *</label>
      <input
        nbInput
        fullWidth
        [(ngModel)]="courseName"
        [placeholder]="'pages.dozent.participants.courseNamePlaceholder' | translate"
        [status]="submitted && !courseName.trim() ? 'danger' : 'basic'"
        autofocus
      />
      <span class="hint-text" *ngIf="submitted && !courseName.trim()">
        {{ "pages.dozent.participants.courseNameRequired" | translate }}
      </span>
    </div>
    <div class="form-group">
      <label class="label">{{ "pages.dozent.participants.courseDescription" | translate }}</label>
      <textarea
        nbInput
        fullWidth
        rows="3"
        [(ngModel)]="description"
        [placeholder]="'pages.dozent.participants.courseDescriptionPlaceholder' | translate"
      ></textarea>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton ghost (click)="close()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      (click)="submit()"
      [disabled]="saving"
    >
      <nb-icon icon="plus" *ngIf="!saving"></nb-icon>
      {{ (saving ? "buttons.saving" : "buttons.create") | translate }}
    </button>
  </nb-card-footer>
</nb-card>
